


























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AxiosStatic } from "axios";
import IResource from '@/interfaces/IResource';
import IAvailability from "@/interfaces/IAvailability";
import {BPopover} from "bootstrap-vue";

interface CalendarDay {
	isToday: boolean;
	isCurrentMonth: boolean;
	isPast: boolean;
	date: Date;
	dateKey: string;
}

@Component({
	components: {BPopover},
})
export default class Calendar extends Vue {

	public $http!: AxiosStatic;

	public month: number = 0;
	public year: number = 0;

	public monthNames: string[] = [
		'',
		'Januar',
		'Februar',
		'März',
		'April',
		'Mai',
		'Juni',
		'Juli',
		'August',
		'September',
		'Oktober',
		'November',
		'Dezember'
	];

	public calendarView: CalendarDay[][] = [[]];

	public resource: IResource | null = null;

	public availability: IAvailability = {};

	@Prop({
		required: true,
		type: Number
	})
	public resourceid!: number;

	get offset(): number {
		let firstDayOfMonth: Date = new Date(this.year, this.month - 1, 1);
		let weekday = firstDayOfMonth.getDay();
		let offset = weekday - 1;
		if (weekday == 1) {
			offset = 0;
		}
		return offset;
	}

	get firstDayOfMonth(): Date {
		return new Date(this.year, this.month - 1, 1);
	}

	get canGoPreviousMonth() {
		let today = new Date();
		return this.year == today.getFullYear() && this.month > today.getMonth() + 1 || this.year > today.getFullYear();
	}

	public hasReservationsPopover(day: CalendarDay): boolean {
		return this.availability && this.availability[day.dateKey] && this.availability[day.dateKey].length > 0;
	}

	public reservationsPopoverText(day: CalendarDay): { status: string, text: string, id: number, start: number }[] {
		let lines: { status: string, text: string, id: number, is_recurring: boolean, start: number }[] = [];
		let availability = this.availability;
		if (availability && availability[day.dateKey]) {
			availability[day.dateKey].forEach(availability => {
				if (availability[2] && availability[2].name) {
					let status = 'new';
					let text = availability[2].name;
					if (availability[0] === 0 && availability[1] === 1440) {
						text = 'Ganztägig: ' + text
					} else {
						text = this.formatTime(availability[0]) + ' - ' + this.formatTime(availability[1]) + ': ' + text
					}
					if (availability[2].type === 'lock') {
						status = 'lock';
						text += ' (Sperrzeit)'
					}
					if (availability[2].status) {
						status = availability[2].status;
					}
					lines.push({status: status, text: text, id: availability[2].id, is_recurring: availability[2].is_recurring ? availability[2].is_recurring : false, start: availability[0]});
				}
			})
		}
		lines = lines.sort((a, b) => a.start - b.start);
		return lines;
	}

	public mounted() {
		let today = new Date();
		this.year = today.getFullYear();
		this.month = today.getMonth() + 1;
		this.loadAvailability();
	}

	@Watch('month')
	public watchMonth() {
		this.buildCalendarView();
	}

	public bookedStyle(day: CalendarDay): { backgroundColor?: string; backgroundImage?: string, backgroundSize?: 'contain' } {
		if (day.dateKey in this.availability) {
			// @ts-ignore
			if (!!window.StyleMedia) {
				return {
					backgroundColor: 'rgba(253, 204, 146, 0.2)',
					backgroundSize: 'contain'
				};
			} else {
				const startminute: number = this.resource!.starttime! * 60;
				const endminute: number = this.resource!.endtime! * 60;
				const rects: string = this.availability[day.dateKey]
					.map((slot): [number, number, any] => [(slot[0] - startminute) / (endminute - startminute), (slot[1] - startminute) / (endminute - startminute), slot[2]])
					.sort((a, b) => {
						// paint locktimes in the background
						if (!a[2] || !b[2]) return 0;
						if (a[2].type === 'lock') return -1;
						if (b[2].type === 'lock') return 1;
						return 0;
					})
					.map((slot) => {
						let fillcolor = 'rgb(253,204,146)';
						let strokecolor = 'rgb(249,193,128)';
						if (slot[2]) {
							if (slot[2].type === 'lock') {
								fillcolor = 'rgb(199,199,199)';
								strokecolor = 'rgb(189,189,189)';
							} else if (slot[2].status === 'confirmed') {
								fillcolor = 'rgb(95,255,135)';
								strokecolor = 'rgb(71,243,114)';
							}
						}
						return `<rect x='0' y='${Math.round(100 * slot[0])}%' width='100%' height='${Math.round(100 * (slot[1] - slot[0]))}%' fill='${fillcolor}' stroke='${strokecolor}'/>`
					})
					.join('');
				return {
					backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'>${encodeURIComponent(rects)}</svg>")`,
					backgroundSize: 'contain'
				}
			}
		} else {
			return {};
		}
	}

	public previousMonth() {
		if(this.canGoPreviousMonth) {
			this.month--;
			if (this.month <= 0) {
				this.month = 12;
				this.year--;
			}
		}
	}

	public nextMonth() {
		this.month++;
		if (this.month > 12) {
			this.month = 1;
			this.year++;
		}
	}

	public buildCalendarView() {
		let view: CalendarDay[][] = [];
		let row;
		for (row = 0; row < 6; row++) {
			view[row] = [];
			let col;
			for (col = 0; col < 7; col++) {
				let calendarDayDate = new Date(this.year, this.month - 1, 1 - this.offset + (col + 7 * row));
				let today = new Date();
				let isToday = false;
				if (today.getFullYear() == calendarDayDate.getFullYear() && today.getMonth() == calendarDayDate.getMonth() && today.getDate() == calendarDayDate.getDate()) {
					isToday = true;
				}
				let isPast = !isToday && calendarDayDate < today;
				let isCurrentMonth = false;
				if (this.firstDayOfMonth.getFullYear() == calendarDayDate.getFullYear() && this.firstDayOfMonth.getMonth() == calendarDayDate.getMonth()) {
					isCurrentMonth = true;
				}
				view[row][col] = {
					isToday: isToday,
					isCurrentMonth: isCurrentMonth,
					date: calendarDayDate,
					isPast: isPast,
					dateKey: calendarDayDate.getFullYear() + '-' + (calendarDayDate.getMonth() + 1) + '-' + calendarDayDate.getDate()
				}
			}
		}
		this.calendarView = view;
	}

	@Watch('resourceid', { immediate: true })
	public loadResource() {
		if (this.resourceid !== 0) {
			this.$http.get(`/private/resource/${ this.resourceid }`).then(response => {
				if (response.status !== 200) {
					throw new Error('no resource found');
				} else {
					this.resource = response.data;
					this.loadAvailability();
				}
			});
		}
	}

	public async loadAvailability(): Promise<void> {
		if (this.resource !== null) {
			try {
				let rangeStart = new Date();
				rangeStart.setMonth(rangeStart.getMonth() - 1, 15);
				let rangeEnd = new Date();
				rangeEnd.setMonth(rangeEnd.getMonth() + 3, 31);
				const resourceId = this.resource.id;

				// load availability for the next 3 months
				let url = '/private/resource/' + this.resource.id + '/availability?start=' + rangeStart.toISOString().substring(0,10) + '&end=' + rangeEnd.toISOString().substring(0,10);
				let response = await this.$http.get(url);

				// if the user has change the list while the availability were loading, we don't want to show the old availability
				if (resourceId != this.resource.id) {
					return;
				}

				this.availability = response.data;

				// load availability for the next 15 years
				rangeEnd.setFullYear(rangeEnd.getFullYear() + 15);
				url = '/private/resource/' + this.resource.id + '/availability?start=' + rangeStart.toISOString().substring(0,10) + '&end=' + rangeEnd.toISOString().substring(0,10);
				response = await this.$http.get(url);

				// if the user has change the list while the availability were loading, we don't want to show the old availability
				if (resourceId != this.resource.id) {
					return;
				}

				this.availability = response.data;
			} catch (e) {
				throw new Error('Error loading availability');
			}
		}
	}

	public formatTime(minutes: number): string {
		let mins: number|string = minutes % 60;
		if (mins < 10) {
			mins = "0" + mins;
		}
		let hours: number|string = Math.floor(minutes / 60);
		if (hours < 10) {
			hours = "0" + hours;
		}
		return hours + ':' + mins;
	}
}
